import styled from 'styled-components';

export const StatusArea = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    svg {
        color: ${props => props.theme.palette.primary.main};
    }

    span {
        text-align: center;
    }
`;
